export default class Subpage {
    constructor() {
        this.init();
    }

    init() {
        // ズームモーダルのイベント追加
        this.addZoom();

        // タブの要素取得
        this.getTab();

        // アコーディオンのイベント追加
        this.addAcc();

        // お問い合わせボタンの表示／非表示の切り替え
        this.cvbtnBehavior();
    }

    addZoom() {
        const $openArray = [...document.querySelectorAll('.c-zoom__open')],
            $zoom = document.querySelector('.c-zoom'),
            $inner = $zoom.querySelector('div'),
            $close = $zoom.querySelector('button');

        $openArray.forEach(($open) => {
            $open.addEventListener('click', () => {
                const $clone = $open.children[0].cloneNode(true);
                $inner.appendChild($clone);
                $zoom.classList.add('-active');
            });
        });

        $close.addEventListener('click', () => {
            $zoom.classList.remove('-active');
        });

        $zoom.addEventListener('transitionend', (e) => {
            if (!e.currentTarget.classList.contains('-active')) {
                $inner.innerHTML = '';
            }
        });
    }

    getTab() {
        const $tabArray = [...document.querySelectorAll('.js-tab')];

        // タブのイベント追加
        $tabArray.forEach(($tab) => this.addTab($tab));
    }

    addTab($tab) {
        const $btnArray = [...$tab.querySelectorAll('.c-tab__btn')],
            $articleArray = [...$tab.querySelectorAll('article')];

        $btnArray.forEach(($btn, i) => {
            $btn.addEventListener('click', () => {
                // アクティブクラス削除
                $btnArray.forEach(($btn) => $btn.classList.remove('-active'));
                $articleArray.forEach(($article) => $article.classList.remove('-active'));

                // アクティブクラス追加
                $btn.classList.add('-active');
                $articleArray[i].classList.add('-active');
            });
        });
    }

    addAcc() {
        const $triggers = document.querySelectorAll('.js-acc_trigger');

        $triggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                const $parent = el.closest('.js-acc');
                const $wrapper = el.nextElementSibling ? el.nextElementSibling : el.previousElementSibling;
                const height = $wrapper.querySelector('.js-acc_cont').offsetHeight;

                el.classList.toggle('-active');
                $wrapper.classList.toggle('-active');

                if (getComputedStyle($wrapper, null).getPropertyValue('height') === '0px') {
                    $wrapper.style.height = `${height}px`;

                    if ($parent !== null) {
                        //高さを足していく
                        $parent.style.height = `${$parent.offsetHeight + height}px`;
                    }
                } else {
                    $wrapper.style.height = 0;

                    if ($parent !== null) {
                        //高さを引いていく
                        $parent.style.height = `${$parent.offsetHeight - height}px`;
                    }
                }
            });
        });
    }

    cvbtnBehavior() {
        const $contact = document.querySelector('.l-contact'),
            $cvbtn = document.querySelector('.l-subpagenav__inquiry');

        if ($contact !== null && $cvbtn !== null) {
            //コンタクトボタンの交差
            window.addEventListener('scroll', () => {
                const tgt = $contact.getBoundingClientRect().top + window.pageYOffset,
                    scb = window.pageYOffset + window.innerHeight;
                if (scb >= tgt) {
                    $cvbtn.classList.add('-hide');
                } else {
                    $cvbtn.classList.remove('-hide');
                }
            });
        }
    }
}
